import { render } from "./VendasDepartamento.vue?vue&type=template&id=c0d93be8"
import script from "./VendasDepartamento.vue?vue&type=script&lang=js"
export * from "./VendasDepartamento.vue?vue&type=script&lang=js"

import "./VendasDepartamento.vue?vue&type=style&index=0&id=c0d93be8&lang=css"

import exportComponent from "C:\\raro\\raro-web\\argon-cel\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__